import Vue from 'vue'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'


export default () => {
  Vue.use(Toast, {
    position: 'top-center'
  })
}
